import axios from "axios";
import { GetSfExecutionSteps } from "types/Flowstep/Flowstep.interface";
import { appConfig } from "utils/config/appConfig";
import { Apptype, AxiosErrorConst, ErrorData, GeneralErrorConst } from "utils/constants";
import { store } from "../store";

export async function getSfExecutions(requestData: { ProcessDate: string }) {
  const state = store.getState();
  const { idToken } = state?.auth?.auth ?? {};
  const config = {
    method: "post",
    url: appConfig.sf_execution_url,
    headers: {
      Authorization: idToken,
      "Content-Type": Apptype,
    },
    data: requestData,
  };
  try {
    const { data } = await axios(config);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.log(AxiosErrorConst, error.message);
      console.log(ErrorData, error.response?.data);
    } else {
      console.log(GeneralErrorConst, error);
    }
    return false;
  }
}

export async function getSfExecutionSteps(requestData: {
  flowDetailId: string;
}): Promise<GetSfExecutionSteps | boolean> {
  const state = store.getState();
  const { idToken } = state.auth.auth;
  const config = {
    method: "post",
    url: appConfig.sf_execution_steps_url,
    headers: {
      Authorization: idToken,
      "Content-Type": Apptype,
    },
    data: requestData,
  };
  try {
    const { data } = await axios(config);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.log(AxiosErrorConst, error.message);
      console.log(ErrorData, error.response?.data);
    } else {
      console.log(GeneralErrorConst, error);
    }
    return false;
  }
}

export async function getSfExecutionStepsReq(requestData: { flowDetailId: string; stepId: string }) {
  const state = store.getState();
  const { idToken } = state.auth.auth;
  const config = {
    method: "post",
    url: appConfig.sf_execution_steps_req_url,
    headers: {
      "Content-Type": Apptype,
      Authorization: idToken,
    },
    data: requestData,
  };
  try {
    const { data } = await axios(config);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.log(AxiosErrorConst, error.message);
      console.log(ErrorData, error.response?.data);
    } else {
      console.log(GeneralErrorConst, error);
    }
    return false;
  }
}

export async function getSfExecutionStepsRes(requestData: { flowDetailId: string; stepId: string }) {
  const state = store.getState();
  const { idToken } = state.auth.auth;
  const config = {
    method: "post",
    url: appConfig.sf_execution_steps_res_url,
    headers: {
      "Content-Type": Apptype,
      Authorization: idToken,
    },
    data: requestData,
  };
  try {
    const { data } = await axios(config);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.log(AxiosErrorConst, error.message);
      console.log(ErrorData, error.response?.data);
    } else {
      console.log(GeneralErrorConst, error);
    }
    return false;
  }
}
